import { createSelector } from "@reduxjs/toolkit";

import type { AppState } from "state/store";

export const getMarkers = (state: AppState) => state.ar.markers;
export const getPolylines = (state: AppState) => state.ar.polylines;
export const getPrisms = (state: AppState) => state.ar.prisms;
export const getGoals = (state: AppState) => state.ar.goals;
export const getModels = (state: AppState) => state.ar.models;
export const getShowArCoverageMesh = (state: AppState) => state.ar.showArCoverageMesh;
export const getLandmarks = (state: AppState) => state.ar.landmarks;

export const getSubjects = (state: AppState) => state.ar.trackerState?.tracksList;
export const getSubjectTrackIndex = (state: AppState) => state.ar.trackerState?.subjectTrackIndex;
export const getIsTracking = createSelector(getSubjectTrackIndex, trackIndex => trackIndex! >= 0);
export const getSelectedMarkerFromParent = (state: AppState) => state.ar.selectedMarkerFromParent;
